<rx-accordion>
  <mat-list>
    <ng-container *ngFor="let item of formCategories">
      <mat-list-item>
        <rx-icon name="icon-folder-rx" class="mr20"></rx-icon>
        {{ item.name }}
      </mat-list-item>
      <mat-list style="margin-left: 30px">
        <div>
          <mat-list-item
            *ngFor="let subItem of filterByCategory(item.id)"
            (click)="selectedItem(subItem.id)"
            [ngClass]="{ selected: selected === subItem.id }"
          >
            <rx-icon name="icon-form2" class="mr20"></rx-icon>
            {{ subItem.name }}
          </mat-list-item>
        </div>
      </mat-list>
    </ng-container>
  </mat-list>
</rx-accordion>
